export default "__VITE_ASSET__Db_3f2Zi__"